import { IAppStore } from '../IAppStore';

const appStoreMigration = (persistedState: unknown, version: number) => {
  if (version === 0) {
    const newState = persistedState as IAppStore;
    newState.selectedBasemapId = newState.selectedBasemapId.replace(
      '::basemaps',
      '::topicmaps.geo.ag.ch',
    );
    return newState;
  }

  if (version === 0.1) {
    const newState = persistedState as IAppStore;
    newState.displayStartUpMessage = false;
    return newState;
  }

  return persistedState as IAppStore;
};

export default appStoreMigration;
